import React, { useState, useEffect, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "./LanguageContext";
import type { Language, LanguageContextType } from "@/contexts/LanguageContext.types";

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({
  children,
}) => {
  const { i18n } = useTranslation();
  const [language, setLanguageState] = useState<Language>("fr");

  useEffect(() => {
    // Set initial language from i18n
    const currentLang = i18n.language as Language;
    if (currentLang === "en" || currentLang === "fr") {
      setLanguageState(currentLang);
    }
  }, [i18n.language]);

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    i18n.changeLanguage(lang);
  };

  const t = (key: string, options?: Record<string, unknown>) => {
    return i18n.t(key, options ?? {});
  };

  const isRTL = false; // RTL support can be added later if needed

  const value: LanguageContextType = {
    language,
    setLanguage,
    t,
    isRTL,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
